export const CVV_ERROR = 'Please confirm your credit card’s security code to place your order.';
